import { a } from '../global-constants';

// Action to store account data distributor from specials-sv response
export const setDesigns = (payload) => {
	return {
		type: a.SET_DESIGNS,
		payload
	};
};
